class TabbedProducts extends HTMLElement {
  connectedCallback() {
    this.tabList = this.querySelector('[data-tabs]');
    this.panels = [...this.querySelectorAll('[data-panel]')];
    if (!this.tabList || this.panels.length === 0) return;

    this.tabs = this.panels.map((panel, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tabbed-products__tab';
      button.setAttribute('role', 'tab');
      button.textContent = panel.dataset.label || `Tab ${index + 1}`;
      button.addEventListener('click', () => this.select(index));
      button.addEventListener('keydown', (event) => this.onKeydown(event, index));
      this.tabList.appendChild(button);
      return button;
    });

    this.select(0);
  }

  onKeydown(event, index) {
    const step = { ArrowRight: 1, ArrowLeft: -1, Home: -Infinity, End: Infinity }[event.key];
    if (step === undefined) return;
    event.preventDefault();
    const last = this.tabs.length - 1;
    let next = index + step;
    if (step === -Infinity) next = 0;
    if (step === Infinity) next = last;
    next = Math.max(0, Math.min(last, next));
    this.select(next);
    this.tabs[next].focus();
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      this.panels[i].hidden = !active;
    });

    this.panels[index].querySelector('tabbed-products-rail')?.refresh();
  }
}

class TabbedProductsRail extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-rail]');
    this.prev = this.querySelector('[data-rail-prev]');
    this.next = this.querySelector('[data-rail-next]');
    if (!this.rail || !this.prev || !this.next) return;

    this.refresh = this.refresh.bind(this);
    this.prev.addEventListener('click', () => this.scrollByPage(-1));
    this.next.addEventListener('click', () => this.scrollByPage(1));
    this.rail.addEventListener('scroll', this.refresh, { passive: true });

    this.observer = new ResizeObserver(this.refresh);
    this.observer.observe(this.rail);
    this.refresh();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  scrollByPage(direction) {
    const card = this.rail.querySelector('[data-rail-item]');
    const step = card ? card.getBoundingClientRect().width + 16 : this.rail.clientWidth;
    const perPage = Math.max(1, Math.floor(this.rail.clientWidth / step));
    this.rail.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
  }

  refresh() {
    if (!this.rail) return;
    const max = this.rail.scrollWidth - this.rail.clientWidth;
    const x = this.rail.scrollLeft;
    this.prev.disabled = x <= 2;
    this.next.disabled = x >= max - 2;
    this.toggleAttribute('data-no-overflow', max <= 2);
  }
}

if (!customElements.get('tabbed-products-rail')) {
  customElements.define('tabbed-products-rail', TabbedProductsRail);
}
if (!customElements.get('tabbed-products')) {
  customElements.define('tabbed-products', TabbedProducts);
}
